import { login, logout, getInfo, loginFromCenter } from '@/api/login'
import { listTeacher } from '@/api/education/teacher'
import { getToken, setToken, removeToken } from '@/utils/auth'
import defAva from '@/assets/images/profile.jpg'

const useUserStore = defineStore(
  'user',
  {
    state: () => ({
      token: getToken(),
      name: '',
      avatar: '',
      userInfo: {},
      roles: [],
      permissions: [],
      loginPath:'/login'
    }),
    actions: {
      // 登录(废弃)
      login (userInfo) {
        const username = userInfo.username.trim()
        const password = userInfo.password
        const code = userInfo.code
        const uuid = userInfo.uuid
        return new Promise((resolve, reject) => {
          login(username, password, code, uuid).then(res => {
            let data = res.data
            setToken(data.access_token)
            this.token = data.access_token
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      },
      //新登录
      loginNew (res) {
        let data = res.data
        setToken(data.access_token)
        this.token = data.access_token
        return Promise.resolve()
      },
      externalUserLogin(data){
        setToken(data.access_token)
        this.token = data.access_token;
        this.loginPath = '/ext/login'
        return Promise.resolve()
      },
      //单点登录
      loginFromCenter (params) {
        return new Promise((resolve, reject) => {
          loginFromCenter(params).then(res => {
            let data = res.data;
            setToken(data.access_token);
            this.token = data.access_token;
            resolve()
          }).catch(error => {
            reject(error)
          })

        })
      },
      // 获取用户信息
      getInfo () {
        return new Promise((resolve, reject) => {
          getInfo().then(res => {
            const user = res.user
            const avatar = (user.avatar == "" || user.avatar == null) ? defAva : user.avatar;
            this.userInfo = Object.assign({}, res.user, { teacherInfo: {} })

            if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
              this.roles = res.roles
              this.permissions = res.permissions
            } else {
              this.roles = ['ROLE_DEFAULT']
            }
            this.name = user.userName
            this.avatar = avatar;

            if (user.employeeNo) {
              listTeacher({
                employeeId: user.employeeNo,
                pageSize: 2000,
                pageNum: 1,
              }).then((listTeacherRes) => {
                if (listTeacherRes && listTeacherRes.code == 200) {
                  try {
                    const rowsUser = (listTeacherRes.rows || []).filter(
                      (item) => item.employeeId == user.employeeNo
                    );

                    if (rowsUser.length > 0) {
                      this.userInfo.teacherInfo = rowsUser[0] || {};
                    }

                    resolve(res);
                  } catch (e) {
                    resolve(res);
                  }
                } else {
                  resolve(res);
                }
              });
            } else {
              resolve(res);
            }
          }).catch(error => {
            reject(error)
          })
        })
      },
      // 退出系统
      logOut () {
        return new Promise((resolve, reject) => {
          logout(this.token).then(() => {
            this.token = ''
            this.roles = []
            this.permissions = []
            removeToken()
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      },
      logOutLocal () {
        return new Promise((resolve, reject) => {
          this.token = ''
          this.roles = []
          this.permissions = []
          removeToken()
          resolve()
        })
      }
    }
  })

export default useUserStore
